export const LIMIT_TIMES = {
  minHour: 0,
  maxHour: 24,
  minMinute: 0,
  maxMinute: 60,
  minSecond: 0,
  maxSecond: 60,
  meridian: 12,
};

export const MERIDIANS = {
  AM: 'AM',
  PM: 'PM',
};

export const DEFAULT_STEP = 1;
export const NUMERIC_REGEX = /[^0-9]/g;

export function formatTwoDigitTimeValue(val: number) {
  const txt = val.toString();
  return txt.length > 1 ? txt : `0${txt}`;
}
